import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';

import DataTable from '../../../../../../../../components/DataTable/DataTable.js';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		padding: 0,
	},
	inner: {
		minWidth: 700,
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	actions: {
		padding: theme.spacing(1),
		justifyContent: 'flex-end',
	},
	primaryButton: {
		color: theme.palette.primary.main
	},
	errorButton: {
		color: theme.palette.error.main
	}
}));

const UsersDataTable = (props) => {
	const { className, data, ...rest } = props;
	const classes = useStyles();

	const _getTableColumns = () => (
		[
			{
				name: 'id',
				label: 'Id',
				options: {
					display: false,
					filter: false,
					viewColumns: false,
					filterType: 'textField',
				}
			},
			{
				name: 'name',
				label: 'Name',
				options: {
					display: true,
					filterType: 'textField',
				}
			}
		]
	);

	const _getTableOptions = () => ({
		filterType: 'dropdown',
		selectableRows: 'none',
		expandableRows: false, // Try Adding This
	});

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<DataTable
				id="usersDataTble"
				title="All Users"
				data={data}
				columns={_getTableColumns()}
				rowsPerPage={10}
				tableBodyCellMaxWidth="250"
				options={_getTableOptions()}
			/>
		</div>
	);
};

UsersDataTable.propTypes = {
	className: PropTypes.string,
	data: PropTypes.array.isRequired,
};

export default UsersDataTable;
